import { sendContainerRequest } from '@/container'

export async function findStudiosByStudioCatalog(query) {
    const result = await sendContainerRequest('findStudiosByStudioCatalog', {
        query,
    })
    return result.data
}
